'use client';

import { use } from 'react';
import { notFound } from 'next/navigation';

import { HomeContainer, HomeSkeleton } from '@/components';
import { useCategories } from '@/services/query/landing.queries';

interface CategoryPageProps {
  params: Promise<{ category: string }>;
}

export default function DynamicCategoryPage({ params }: CategoryPageProps) {
  const { category: categorySlug } = use(params);

  const { data, isLoading } = useCategories();

  if (isLoading) {
    return <HomeSkeleton />;
  }

  const category = data?.find((cat) => cat.slug === categorySlug);

  if (!category) {
    notFound();
  }

  return <HomeContainer />;
}
